/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* CUSTOM ANDREA SALUGEA - 08/10/2026: tolto il blocco "if(window.location.href.includes('product'))" di Synesthesia.
   Conteneva il vecchio sticky add-to-cart, gia' commentato (oggi la barra fissa e' il blocco app "Barra fissa carrello"),
   e un evento di tracciamento "CustomClick_AddToCart" via gtag/ga che non ha mai funzionato: gtag non esiste sul sito,
   click_position non veniva piu' valorizzato e Google Tag Manager non ha trigger per quell'evento. Produceva solo errori
   in console. Se servira' di nuovo il tracciamento per posizione, va rifatto con dataLayer.push + trigger in GTM. */


/* codice per scrivere paramento PR (prodotto) su pagina contatti in campo nascosto form */
if(window.location.href.includes('contatti')) {
    //document.addEventListener("DOMContentLoaded", function () {
        var contactFormProvenienza = document.querySelector('.contactFormProvenienza');
        if (contactFormProvenienza !== null) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const nomeProdotto = urlParams.get('pr');
            contactFormProvenienza.value = nomeProdotto;
        }
    //});
}




/* codice per svuotare i cookie e riallineare il carrello */
  if(window.location.href.includes('cart?cookie=clear')) {
    document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
    //window.location.replace("/discount/BFSALUGEA?redirect=/collections/prodotti");
    window.location.replace("/collections/prodotti?fix="+btoa('cart_reset'));
  }

/* codice per svuotare i cookie e ricreare il carrello */
 if(window.location.href.includes('cart?cookie=recreate')) {
    document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
    let address = window.location.search 
    parameterList = new URLSearchParams(address);
    dataCarrello = parameterList.get("b");

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: atob(dataCarrello)
    })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });

    //window.location.replace("/discount/12ANNI?redirect=/cart");
    window.location.replace("/cart?fix="+btoa('cart_reset'));
  }
  



/* codice per controllare parametro FIX= e mandare evento google */
if (window.location.href.indexOf('?fix=') > 0) {
  function check_ga() {
    if (typeof gtag === 'function') {
      const urlParams = new URLSearchParams(window.location.search);
      const var1 = atob(urlParams.get('fix'));
         console.log('evento debug: '+var1); 
           gtag("event", "bugfix", { "event_category": var1,  "event_label": var1  });
    } else {
      setTimeout(check_ga,500);
    }
  }
  check_ga();    
}




/* codice per nascondere ancore video non url */
  if(window.location.href.includes('pages/video#')) {
    document.querySelectorAll('.galleryVideo').forEach(function(el) {
       el.style.display = 'none';
    });
    document.querySelectorAll(location.hash).forEach(function(el) {
       el.style.display = 'block';
    });
  }


/* apertura form da CLASSE klaviyoFormBtn  
if (document.querySelector('.klaviyoFormBtn') != null) {
    document.querySelector('.klaviyoFormBtn').addEventListener('click', function (){
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', this.dataset.klaviyoform]);
      });
}*/

if (document.querySelector('.klaviyoFormBtn') != null) {
  console.log('klaviyoFormBtn');
   const cbox = document.querySelectorAll(".klaviyoFormBtn");
   for (let i = 0; i < cbox.length; i++) {
       cbox[i].addEventListener("click", function() {
         console.log(cbox[i]);
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', this.dataset.klaviyoform]);
       });
   }
}



if (document.querySelector('.klaviyoTriggerPromoImmunogea') != null) {
   const cbox = document.querySelectorAll(".klaviyoTriggerPromoImmunogea");
   for (let i = 0; i < cbox.length; i++) {
       cbox[i].addEventListener("click", function() {
         console.log(cbox[i]);
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', 'USvXjj']);
       });
   }
}




function openPopUpFromBullet(){
  return document.getElementById('bannerPromoCustom').click();
}

function scrollToElement( idElement ) {
        const element = document.getElementById(idElement);
        let position = element.getBoundingClientRect();
        window.scrollTo( { top: position.top + window.scrollY - 180, left: 0, behavior: 'smooth'} );
        //element.scrollIntoView( { behavior: 'smooth'} );
      }





  


document.addEventListener('DOMContentLoaded', function () {
  // Esegui solo su /collections/prodotti (adatta se serve)
  if (!location.pathname.startsWith('/collections/prodotti')) return;

  // Evita log duplicati nella stessa sessione
  if (sessionStorage.getItem('bfplus_seen')) return;

  // Helper cookie
  function getCookie(name) {
    const m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  
  // 1) tenta via referrer (se inviato)
  let triggered = false;
  if (document.referrer) {
    try {
      const ref = new URL(document.referrer);
      if (ref.origin === location.origin && ref.pathname.startsWith('/discount/'+code)) {
        console.log('sconto bf plus');
        sessionStorage.setItem('bfplus_seen', '1');
        triggered = true;
        fetch("/checkout?discount=CLEAR")
        .then(() => {
          console.log("Sconti precedenti rimossi, applico:", code);
           fetch("/checkout?discount=CLEAR")
            .then(() => {
              console.log("applicato:", code);
              
            })
        })
      }
    } catch (e) { /* ignore URL parse errors */ }
  }

  // 2) fallback: cookie impostato da Shopify
  if (!triggered) {
    const code = getCookie('discount_code');
    if (code && code.toUpperCase() === 'BFPLUS') {
      console.log('sconto bf plus');
      sessionStorage.setItem('bfplus_seen', '1');
      fetch("/checkout?discount=CLEAR")
        .then(() => {
          console.log("Sconti precedenti rimossi, applico:", code);
           fetch("/checkout?discount="+code)
            .then(() => {
              console.log("applicato:", code);
              
            })
        })
    }
  }
});






document.addEventListener("DOMContentLoaded", function () {

    if(window.location.href.includes('/products/')) {
    var aContattiProvenienza = document.querySelector('a[href="https://salugea.com/pages/contatti?pr=0"]');
    if (aContattiProvenienza) {
      aContattiProvenienza.setAttribute('href', 'https://salugea.com/pages/contatti?pr='+window.location.href)
    }    
  }

  // Alla fine del DOM    link-test-benessere
//const MBultimoLi = document.querySelector('.nav-bar__linklist > li:last-child');
const MBultimoLink = document.querySelector('.nav-bar__linklist > li:last-child').querySelector('a');

const mobileMenuRoot = document.querySelector('.mobile-menu__nav:not(.is_nested)');
const mobileLinks = mobileMenuRoot.querySelectorAll(':scope > li > a.mobile-menu__nav-link');
const MBultimoMobileLink = mobileLinks[mobileLinks.length - 1];

MBultimoLink.addEventListener('click', function (e) {
    e.preventDefault();
    apriTestBenessere();
});
MBultimoMobileLink.addEventListener('click', function (e) {
    e.preventDefault();
    apriTestBenessere();
});


    const links = document.querySelectorAll(".link-test-benessere");

    links.forEach(link => {
        link.addEventListener("click", function (e) {
            e.preventDefault();
            apriTestBenessere();
        });
    });
});

function apriTestBenessere() {
    const isDesktop = rilevaDesktop();
    if (isDesktop) {
        // Desktop → apri pagina
        window.location.href = "https://salugea.com/pages/test-integratori";
    } else {
        // Mobile → popup
        //ApriPopuo('1124');
        window.location.href = "https://salugea.com/pages/test-integratori";
    }
}

/* ============================
   Funzione detection avanzata
   ============================ */
function rilevaDesktop() {
    const width = window.innerWidth;

    // 1. Se ha puntatore fine + no touch → quasi sicuramente desktop
    const pointerFine = window.matchMedia("(pointer: fine)").matches;
    const noTouch = navigator.maxTouchPoints === 0;

    // 2. Schermo grande
    const largeScreen = width >= 1024;

    // Logica combinata
    if ((pointerFine && noTouch) || (largeScreen && noTouch)) {
        return true; // desktop
    }

    // Altrimenti è mobile/tablet
    return false;
}






  function applicaCoupon(couponCode, viewToast) {
    if (!couponCode) return;

    var encodedCoupon = encodeURIComponent(couponCode);

    fetch('/discount/' + encodedCoupon, {
      method: 'GET',
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Errore applicazione coupon');
        }

        if(viewToast){ showCouponToast('Codice sconto "' + couponCode + '" applicato al carrello'); }
      })
      .catch(function () {
        if(viewToast){showCouponToast('Non è stato possibile applicare il codice sconto', true); }
      });
  }

  function showCouponToast(message, isError) {
    var existingToast = document.querySelector('.coupon-toast');

    if (existingToast) {
      existingToast.remove();
    }

    var toast = document.createElement('div');
    toast.className = 'coupon-toast' + (isError ? ' coupon-toast--error' : '');
    toast.textContent = message;

    document.body.appendChild(toast);

    setTimeout(function () {
      toast.classList.add('is-visible');
    }, 50);

    setTimeout(function () {
      toast.classList.remove('is-visible');

      setTimeout(function () {
        toast.remove();
      }, 300);
    }, 3500);
  }



// SYNESTHESIA - FIX cambio prezzo dell'abbonamento
document.addEventListener('DOMContentLoaded', function () {
  function updateTopPrice(radio) {
    var scope = radio.closest('.product-form') || document;
    var highlight = scope.querySelector('.price.price--highlight');
    var compare = scope.querySelector('.price.price--compare');
    if (!radio || !highlight) return;

    var priceText = (radio.dataset.variantPrice || '').replace(/\s*EUR\s*$/, '');
    var compareText = (radio.dataset.variantCompareAtPrice || '').replace(/\s*EUR\s*$/, '');

    var hiddenHighlight = highlight.querySelector('.visually-hidden');
    highlight.innerHTML = '';
    if (hiddenHighlight) highlight.appendChild(hiddenHighlight);
    highlight.appendChild(document.createTextNode(priceText));

    if (compare) {
      var hiddenCompare = compare.querySelector('.visually-hidden');
      if (compareText && compareText !== priceText) {
        compare.style.display = '';
        compare.innerHTML = '';
        if (hiddenCompare) compare.appendChild(hiddenCompare);
        compare.appendChild(document.createTextNode(compareText));
      } else {
        compare.style.display = 'none';
      }
    }
  }

  // 1) click diretto su un'opzione di consegna
  document.querySelectorAll('.shopify_subscriptions_fieldset input[type="radio"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (radio.checked) updateTopPrice(radio);
    });
  });

  // 2) quando si cambia confezione (variante), il blocco abbonamenti si nasconde/mostra
  //    da solo senza scatenare un evento "change" sul radio già selezionato: osserviamolo
  //    e, se il blocco torna visibile con un'opzione ancora selezionata, ri-applichiamo il prezzo.
  document.querySelectorAll('.shopify_subscriptions_app_block').forEach(function (block) {
    var observer = new MutationObserver(function () {
      if (!block.classList.contains('shopify_subscriptions_app_block--hidden')) {
        var checked = block.querySelector('input[type="radio"]:checked');
        if (checked) updateTopPrice(checked);
      }
    });
    observer.observe(block, { attributes: true, childList: true, subtree: true });
  });
});


/* CUSTOM SYNESTHESIA START */
function initSynesthesiaCartGuard() {
  if (document.querySelector('.template-cart')) {
    var agree = document.querySelector('#checkBoxTerminiCondizioni');
    var agree_error = document.querySelector('#checkout-is-required-input');

    // Nasconde di nuovo l'errore appena l'utente spunta la checkbox
    if (agree) {
      agree.addEventListener('change', function () {
        if (agree.checked && agree_error) {
          agree_error.setAttribute('hidden', 'hidden');
        }
      });
    }

    // Blocca il checkout se la checkbox non è spuntata, mostra l'errore
    // e scrolla con animazione fino alla checkbox (vale anche per il
    // tasto sticky, che è lo stesso identico bottone)
    document.body.addEventListener('click', function (event) {
      if (event.target.matches('#submitCartBtn')) {
        if (agree && !agree.checked) {
          event.preventDefault();
          if (agree_error) {
            agree_error.removeAttribute('hidden');
          }
          var scrollTarget = document.querySelector('.checkBoxTerminiCondizioni') || agree;
          scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
          scrollTarget.classList.add('synesthesia-highlight');
          setTimeout(function () {
            scrollTarget.classList.remove('synesthesia-highlight');
          }, 1500);
        }
      }
    });
  }
}

/* CUSTOM SYNESTHESIA START - mostra il tasto sticky solo quando il tasto nel corpo scompare */
function initSynesthesiaStickyCheckoutReveal() {
  var stickyContainer = document.querySelector('.cart-recap__checkout_sticky_container');
  if (!stickyContainer || !('IntersectionObserver' in window)) return;

  // Segnaposto invisibile: marca la posizione naturale del tasto nel corpo della pagina
  var sentinel = document.createElement('div');
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.cssText = 'height:1px;';
  stickyContainer.parentNode.insertBefore(sentinel, stickyContainer);

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      stickyContainer.classList.toggle('is-visible', !entry.isIntersecting);
    });
  }, { threshold: 0 });

  observer.observe(sentinel);
}
/* CUSTOM SYNESTHESIA END */

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initSynesthesiaCartGuard();
    initSynesthesiaStickyCheckoutReveal();
  });
} else {
  initSynesthesiaCartGuard();
  initSynesthesiaStickyCheckoutReveal();
}
/* CUSTOM SYNESTHESIA END */



/* CUSTOM SYNESTHESIA START FIX CARRELLO + MENU MOBILE */
(function () {
  function init() {
    var HEADER_SELECTOR = '.shopify-section-group-header-group.shopify-section__header';
    // bottoni che, al click, attivano il lock dell'header (carrello + menu mobile)
    var TOGGLE_SELECTORS = '.header__cart-toggle, .header__mobile-nav-toggle';

    // trova la regola CSS "html.is-locked ... { position: fixed !important; top: 0px !important; ... }"
    function findHeaderLockRule() {
      for (var i = 0; i < document.styleSheets.length; i++) {
        var rules;
        try { rules = document.styleSheets[i].cssRules; } catch (e) { continue; }
        if (!rules) continue;
        for (var j = 0; j < rules.length; j++) {
          if (rules[j].selectorText === 'html.is-locked ' + HEADER_SELECTOR) return rules[j];
          if (rules[j].cssRules) {
            for (var k = 0; k < rules[j].cssRules.length; k++) {
              if (rules[j].cssRules[k].selectorText === 'html.is-locked ' + HEADER_SELECTOR) {
                return rules[j].cssRules[k];
              }
            }
          }
        }
      }
      return null;
    }

    var headerLockRule = findHeaderLockRule();
    if (!headerLockRule) return;

    document.addEventListener('click', function (e) {
      if (!e.target.closest(TOGGLE_SELECTORS)) return;
      var alreadyLocked = document.documentElement.classList.contains('is-locked');
      if (alreadyLocked) return; // si sta chiudendo, non serve fare nulla

      var header = document.querySelector(HEADER_SELECTOR);
      var currentTop = header.getBoundingClientRect().top;
      headerLockRule.style.setProperty('top', currentTop + 'px', 'important');
    }, true); // capture: gira PRIMA che il tema blocchi lo scroll
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* CUSTOM SYNESTHESIA END */








/* CUSTOM ANDREA SALUGEA - Widget abbonamenti: due riquadri, badge sconto e prezzi a destra - 08/10/2026
 * Aggiornato 08/10/2026: listino barrato anche su "Acquisto singolo" (solo se il prodotto e' scontato), riquadro attivo evidenziato.
 * Sostituisce lo script che stava nella sezione "Custom Liquid" del template prodotto (lo stile e' in assets/custom.css).
 * - divide il titolo del gruppo in titolo + badge ("Abbonati e risparmia: 25% di sconto")
 * - toglie il prezzo dal nome del piano ("Consegna ogni mese, 32,18 €" -> "Consegna ogni mese"), anche nel formato inglese ("€32.18")
 * - "Acquisto singolo": mostra il prezzo pieno barrato solo se c'e' uno sconto a listino (compare-at maggiore del prezzo)
 * - piani in abbonamento: mostra il prezzo pieno di listino barrato accanto al prezzo dell'abbonamento
 * - porta il prezzo barrato delle opzioni in abbonamento (data-variant-compare-at-price) al prezzo di listino:
 *   cosi' anche il prezzo in alto (updateTopPrice, qui sopra) e la barra sticky mostrano sempre il listino barrato
 * - mette la classe sal-active sul riquadro che contiene l'opzione selezionata
 * - "Acquisto singolo" scontato a listino: aggiunge la stessa etichetta del riquadro abbonamento con la percentuale di sconto
 *   (es. "20% di sconto"; il testo segue il modello dell'etichetta abbonamento, cambia solo il numero)
 * Il listino si legge dall'opzione "Acquisto singolo" della stessa variante, quindi resta giusto anche senza promo.
 * Ogni passaggio modifica la pagina solo se serve, cosi' il MutationObserver non entra in loop. */
(function () {
  var PRICE_IN_NAME = /,?\s*(?:€\s?)?\d{1,3}(?:[.,]\d{3})*[.,]\d{2}\s*(?:€|EUR)?\s*$/;

  function cleanPrice(text) {
    return (text || '').replace(/\s*EUR\s*$/, '').trim();
  }

  // "€ 1.234,56" / "€ 42,90" / "€42.90" -> numero
  function toNumber(text) {
    var digits = (text || '').replace(/[^\d,.]/g, '');
    if (digits.indexOf(',') > -1) digits = digits.replace(/\./g, '').replace(',', '.');
    var value = parseFloat(digits);
    return isNaN(value) ? 0 : value;
  }

  function setClass(element, name, on) {
    if (element && element.classList.contains(name) !== on) element.classList.toggle(name, on);
  }

  // Testo dell'etichetta di "Acquisto singolo": stesso modello di quella dell'abbonamento, con la percentuale giusta
  function discountBadgeText(block, percent) {
    var model = block.querySelector('.subscription_group:not(:first-child) .sal-sub-badge');
    var text = model ? model.textContent : '';
    if (/\d+(?:[.,]\d+)?\s*%/.test(text)) return text.replace(/\d+(?:[.,]\d+)?\s*%/, percent + '%');
    return percent + '% ' + ((document.documentElement.lang || '').indexOf('en') === 0 ? 'off' : 'di sconto');
  }

  function setOneTimeBadge(group, text) {
    var badge = group.querySelector(':scope > .sal-sub-badge');
    if (!text) {
      if (badge) badge.remove();
    } else {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'sal-sub-badge';
        group.appendChild(badge);
      }
      if (badge.textContent !== text) badge.textContent = text;
    }
    setClass(group, 'sal-has-badge', !!text);
    setClass(group.closest('.plan_card'), 'sal-has-top-badge', !!text);
  }

  function setStrike(wrapper, value) {
    var strike = wrapper.querySelector('.sal-sub-full');
    if (!value) {
      if (strike) strike.remove();
      return;
    }
    if (!strike) {
      strike = document.createElement('s');
      strike.className = 'sal-sub-full';
      strike.setAttribute('aria-hidden', 'true');
      wrapper.insertBefore(strike, wrapper.querySelector('.in_widget_price'));
    }
    if (strike.textContent !== value) strike.textContent = value;
  }

  function splitGroupName(block) {
    block.querySelectorAll('.subscription_group .group_name').forEach(function (name) {
      if (name.dataset.salSplit) return;
      var parts = name.textContent.trim().match(/^(.*?)\s*:\s*(.+)$/);
      if (!parts) return;
      name.dataset.salSplit = '1';
      name.textContent = parts[1];
      var group = name.closest('.subscription_group');
      if (group && !group.querySelector('.sal-sub-badge')) {
        var badge = document.createElement('span');
        badge.className = 'sal-sub-badge';
        badge.textContent = parts[2];
        group.appendChild(badge);
      }
    });
  }

  // Acquisto singolo: barrato solo se c'e' sconto a listino. Restituisce il prezzo pieno di listino.
  function updateOneTime(block) {
    var oneTime = block.querySelector('input[data-radio-type="one_time_purchase"]');
    if (!oneTime) return '';
    var price = cleanPrice(oneTime.dataset.variantPrice);
    var compare = cleanPrice(oneTime.dataset.variantCompareAtPrice);
    var onSale = compare && toNumber(compare) > toNumber(price);
    var wrapper = oneTime.closest('.title_and_price_wrapper');
    if (wrapper) setStrike(wrapper, onSale ? compare : '');
    var group = oneTime.closest('.subscription_group');
    var percent = onSale ? Math.round((1 - toNumber(price) / toNumber(compare)) * 100) : 0;
    if (group) setOneTimeBadge(group, percent > 0 ? discountBadgeText(block, percent) : '');
    return onSale ? compare : price;
  }

  function updatePlans(block, full) {
    block.querySelectorAll('input[data-radio-type="selling_plan"]').forEach(function (radio) {
      var showFull = full && toNumber(full) > toNumber(cleanPrice(radio.dataset.variantPrice));
      if (showFull && radio.dataset.variantCompareAtPrice !== full) radio.dataset.variantCompareAtPrice = full;

      var row = radio.closest('label');
      var wrapper = row && row.querySelector('.title_and_price_wrapper');
      if (!wrapper) return;

      var name = wrapper.querySelector(':scope > span');
      if (name && PRICE_IN_NAME.test(name.textContent)) {
        name.textContent = name.textContent.replace(PRICE_IN_NAME, '').trim();
      }

      setStrike(wrapper, showFull ? full : '');
    });
  }

  function updateActive(block) {
    block.querySelectorAll('.subscription_group').forEach(function (group) {
      setClass(group, 'sal-active', !!group.querySelector('input[type="radio"]:checked'));
    });
  }

  function apply() {
    document.querySelectorAll('.shopify_subscriptions_app_block').forEach(function (block) {
      splitGroupName(block);
      updatePlans(block, updateOneTime(block));
      updateActive(block);
    });
  }

  var queued = false;
  function queueApply() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      apply();
    });
  }

  function init() {
    if (!document.querySelector('.shopify_subscriptions_app_block')) return;
    apply();
    new MutationObserver(queueApply).observe(document.body, { childList: true, subtree: true });
    // il cambio di opzione non modifica il DOM: aggiorna subito il riquadro attivo
    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('.shopify_subscriptions_fieldset')) apply();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* CUSTOM ANDREA SALUGEA END */
